import React from 'react';
import { FadeIn, Section, Button } from './ui';
import { Check } from 'lucide-react';
export function BaseOfferSection() {
  return <Section variant="dark" id="pricing" className="!py-2 md:!pb-4 md:!pt-14" data-id="element-16">
      <FadeIn data-id="element-17">
        <div className="text-center mb-2 md:mb-5" data-id="element-18">
          <p className="text-brand-orange text-[9px] md:text-xs font-bold tracking-widest uppercase mb-0.5 md:mb-2" data-id="element-19">
            Elegí tu plan
          </p>
          <h2 className="text-lg md:text-4xl font-black text-white" data-id="element-20">
            MATEMÁTICA 360
          </h2>
        </div>

        {/* Base Offer Card — ultra compact on mobile */}
        <div className="bg-dark-light/40 border border-gray-800 rounded-lg md:rounded-2xl p-3 md:p-7" data-id="element-21">
          <div className="flex items-center justify-between mb-1.5 md:mb-3" data-id="element-22">
            <h3 className="text-sm md:text-xl font-bold text-white" data-id="element-23">
              Sistema Completo
            </h3>
            <span className="text-gray-500 text-[8px] md:text-xs font-medium px-1.5 py-0.5 rounded-full border border-gray-700" data-id="element-24">
              BASE
            </span>
          </div>

          <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[10px] md:text-sm text-gray-400 mb-2 md:mb-4" data-id="element-25">
            <span className="flex items-center gap-1" data-id="element-26">
              <Check size={10} className="text-brand-orange" data-id="element-27" />6 Tomos + 3 Bonus
            </span>
            <span className="flex items-center gap-1" data-id="element-28">
              <Check size={10} className="text-brand-orange" data-id="element-29" />
              PDF al instante
            </span>
            <span className="flex items-center gap-1" data-id="element-30">
              <Check size={10} className="text-brand-orange" data-id="element-31" />
              Pago único
            </span>
          </div>

          <div className="flex items-center justify-between gap-3" data-id="element-32">
            <div className="shrink-0" data-id="element-33">
              <span className="text-gray-500 text-[9px] md:text-xs line-through mr-1" data-id="element-34">
                $59.910
              </span>
              <span className="text-xl md:text-4xl font-black text-brand-orange" data-id="element-35">
                $19.990
              </span>
            </div>
            <a href="https://profelisto.com.ar/checkouts/cn/hWNBbWBBuPtR7PmmhGLmMEAk/es-ar?_r=AQABhCozGeJpKfIo6Q_lyWnmdh6WBRiDoew2JdGEzcJTsM0" className="shrink-0 border-2 border-brand-orange text-brand-orange font-bold text-[11px] md:text-base px-4 md:px-6 py-2 md:py-3 rounded-xl text-center active:scale-[0.98] transition-all md:hover:-translate-y-1" data-id="element-36">
              QUIERO ESTE →
            </a>
          </div>
        </div>
      </FadeIn>
    </Section>;
}